import { render, staticRenderFns } from "./FileMarkdownIcon.vue?vue&type=template&id=4747e155&scoped=true&"
import script from "./FileMarkdownIcon.vue?vue&type=script&lang=js&"
export * from "./FileMarkdownIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4747e155",
  null
  
)

export default component.exports